import {createBox} from '@shopify/restyle';
import {Theme} from '../core/theme/restyle';

export const Box = createBox<Theme>();
